import { useWalletConnection } from '@/hooks';
import { ContextCreator, apiClient, useApiQuery, Schemas } from '@/libs';
import { TSetState } from '@/types/TSetState';
import { MutableRefObject, ReactNode, useRef, useState } from 'react';
import { useUserContext } from './User';

type PlatformData = Schemas.Platform.PlatformResponseType;

const initialValue: Partial<
  PlatformData & {
    isLoading: boolean;
    refetch: Function;
    hoursRemaining: number;
    setHoursRemaining: TSetState<number | null>;
    progressedCounter: MutableRefObject<number | null>;
    withdrawStatus: 'active' | 'deactive';
    setWithdrawStatus: TSetState<'active' | 'deactive' | null>;
  }
> = {};
export const [PlatformProvider, usePlatformData] = ContextCreator(initialValue);

export function PlatformDataContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [hoursRemaining, setHoursRemaining] = useState<number | null>(null);
  const [withdrawStatus, setWithdrawStatus] = useState<number | null>(null);
  const progressedCounter = useRef<number | null>(null);
  const { isConnected, address } = useWalletConnection();
  const { data } = useUserContext();

  const hasToken =
    !!data?.token ||
    (typeof window !== 'undefined' && !!localStorage.getItem('accessToken'));

  const {
    data: platform,
    isLoading,
    refetch,
  } = useApiQuery(
    ['platform'],
    () => apiClient.getPlatform(),
    {
      enabled: Boolean(isConnected && address && hasToken),
    }
  );

  return (
    <PlatformProvider
      value={[
        {
          ...platform?.data,
          isLoading,
          refetch,
          hoursRemaining,
          setHoursRemaining,
          progressedCounter,
          withdrawStatus,
          setWithdrawStatus,
        },
      ]}
    >
      {children}
    </PlatformProvider>
  );
}
